<template>
    <div class="main">
        <div class="bg-white">
            <!-- Hero & active addresses toggle -->
            <div class="container accountDeliveryAddresses__container mx-auto text-center p-4 py-0 pb-4">
                <h2 v-text="$t('RESTART_PAGE_ALL_SET_UP')"></h2>
                <p class="py-4 w-full" v-text="$t('RESTART_PAGE_RESTARTED')"></p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'RestartAccountConfirmationPage',
};
</script>
